// extracted by mini-css-extract-plugin
module.exports = {"AllMaterialsButton":"all-materials-button_AllMaterialsButton__xJGcy"};